// removed by extract-text-webpack-plugin
module.exports = {"ui":"button_ui_3fvpyl","content":"button_content_6g8u7h","icon":"button_icon_bxgde9","label":"button_label_85vcr4","withDisabled":"button_withDisabled_aqft39","withDanger":"button_withDanger_3fhwpg","withInverse":"button_withInverse_77gwme"};


//////////////////
// WEBPACK FOOTER
// ./packages/lib-ui/src/button/button.scss
// module id = 555
// module chunks = 0